import { useEffect, useState } from 'react';
import { heroMeta } from '@/mocks/home';

const navItems = [
  { label: '实时快讯', href: '#flash' },
  { label: '热度榜单', href: '#board' },
  { label: '焦点封面', href: '#focus' },
  { label: '话题聚合', href: '#topics' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const light = !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/80'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-6">
        <a href="#top" className="flex items-center gap-3 group">
          <span className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-black text-lg md:text-xl">
            看
          </span>
          <span className="flex flex-col leading-none">
            <h1
              className={`font-heading font-black text-xl md:text-2xl tracking-tight m-0 ${
                light ? 'text-background-50' : 'text-foreground-950'
              }`}
            >
              看料91
            </h1>
            <span
              className={`hidden sm:block text-[11px] tracking-[0.28em] mt-1 ${
                light ? 'text-background-200/80' : 'text-foreground-500'
              }`}
            >
              {heroMeta.issue}
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                light
                  ? 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span
            className={`hidden md:inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium ${
              light
                ? 'bg-background-50/15 text-background-50 border border-background-50/25'
                : 'bg-secondary-100 text-secondary-900 border border-secondary-200'
            }`}
          >
            <span className="relative flex w-2 h-2">
              <span className="absolute inline-flex w-full h-full rounded-full bg-primary-500 animate-pulse-dot" />
            </span>
            实时更新中
          </span>

          <a
            href="#board"
            className="hidden sm:inline-flex items-center gap-2 px-4 md:px-5 py-2 md:py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line" />
            </span>
            看热榜
          </a>

          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              light
                ? 'text-background-50 hover:bg-background-50/10'
                : 'text-foreground-950 hover:bg-background-100'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 md:px-8 py-4">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-base font-medium text-foreground-800 border-b border-background-200/70 last:border-b-0"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}